import { gql } from '@apollo/client';

export const FETCH_SCHOOLS = gql`
  query FetchSchools {
    schools {
      id
      name
      username
      imageUrl
    }
  }
`;
